<template>
    <div class="payCert">
        <div class="title">
            Ukey支付
            <span style="color: red;font-size: 13px;">注:购买Ukey介质后进行Ukey电子印章制作</span>
        </div>
        <div class="pay">
            <div class="mkll">
                名称： 
                <span v-if="priceType==0">Ukey + 年证书</span>
                <span v-else-if="priceType==1">Ukey</span>
            </div>
            <div class="mkll">
                金额（元）：
                <div class="money"><span>￥</span>{{ukeyPrice}}</div>
            </div>
            <div class="mkll">
                实付款（元）：
                <div class="money"><span>￥</span>{{ukeyPrice}}</div>
            </div>

            <div class="line"></div>

            <div class="title">
                付款方式
            </div>
            <div class="select">
                <div class="moneyPay">
                    <el-checkbox v-model="payZFBChecked" @change="payZFB"></el-checkbox>
                    <img src="../../../../static/img/zhifubao.png"/>
                    企业支付宝
                </div>
                <div class="moneyPay">
                    <el-checkbox v-model="payWXChecked" @change="payWX"></el-checkbox>
                    <img src="../../../../static/img/wx.png"/>
                    微信
                </div>
            </div>
            <div class="line"></div>
            <div class="pay_btn">
                <div class="btn" @click="handlCheckSubmit">提交</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                signatureId:'',
                ukeyPrice:'',
                payZFBChecked: true,
                payWXChecked: false,
                orderList: '',
                priceType: 0,
            }
        },
        mounted() {
            if (!  this.$route.params.id  ) {
                this.$router.push('sealListZhang');
            } else {
                console.log( this.$route.params.type );
                this.priceType =  this.$route.params.type;
                this.getUkeyPrice( this.priceType );
                this.signatureId =   this.$route.params.id;
            }
        },
        methods: {
            getUkeyPrice(){
                let _this = this;
                let param = new FormData();
                param.append('token', _this.$global.token);
                param.append('priceType',  _this.priceType );

                // 【API请求】---获取Ukey价格  0标识首次申请Ukey+证书   1标识追加申请Ukey 
                _this.api.getUdunPrice(param).then(res => {
                    console.log( res ); 
                    this.ukeyPrice = res.data;
                })

            },

            handlCheckSubmit() {
                let _this = this;
                _this.$confirm('是否下单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: ''
                }).then(() => {
                    let param = new FormData();
                    if( this.priceType==0){
                        param.append('type',  3 );
                    }else{
                        param.append('type',  2 );
                    }
                    param.append('token', _this.$global.token);
                    param.append('signatureId',  this.signatureId );
                    // param.append('certId', this.signatureId );
                    if (_this.payZFBChecked) {
                        param.append('orderChannel', 0);
                    } else if (_this.payWXChecked) {
                        param.append('orderChannel', 1);
                    }
                    //【API请求】---生成支付订单
                    _this.api.addOrderInfo(param).then(res => {
                        console.log(res);
                        _this.$message.success('下单成功');
                        _this.$router.push('myOrder');
                    })
                }).catch(() => {
                    
                })
            },
            payZFB() {
                this.payWXChecked = !this.payWXChecked
            },
            payWX() {
                this.payZFBChecked = !this.payZFBChecked
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .payCert {
        width: @a;
        height: auto;
        margin-left: 4%;

        .title {
            width: @a;
            height: 24px;
            font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            font-weight: bolder;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
        }

        .pay {
            width: @a;
            height: auto;
            margin-top: 27px;
            padding: 5px;

            .pay_btn {
                width: @a;
                height: 80px;
                @row();

                .btn {
                    width: 520px;
                    height: 80px;
                    line-height: 80px;
                    text-align: center;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#000000,
                    #000000);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    letter-spacing: 1px;
                    color: #ffffff;
                    font-size: 24px;
                    cursor: pointer;
                }
            }

            .line {
                width: @a;
                height: 4px;
                margin: 30px 0;
                background-image: linear-gradient(to right,
                grey 0%,
                grey 50%,
                transparent 50%);
                background-size: 30px 1px;
                background-repeat: repeat-x;
            }

            .select {
                width: @a;
                height: auto;
                display: @flex;
                align-items: center;
                font-size: 24px;
                font-weight: bolder;
                padding-left: 20px;

                .moneyPay {
                    width: 50%;
                    height: 150px;
                    display: @flex;
                    align-items: center;

                    img {
                        width: 70px;
                        height: 70px;
                        object-fit: cover;
                        margin: 0 15px;
                    }
                }
            }

            .mkll {
                width: @a;
                height: auto;
                margin-top: 20px;
                font-weight: bolder;
                font-size: 20px;
                display: @flex;
                align-items: center;

                span {
                    font-size: 18px;
                    font-weight: 500;
                    margin-left: 5px;
                }

                .money {
                    width: auto;
                    font-size: 28px;
                    font-weight: bolder;
                    margin-left: 5px;

                    span {
                        font-size: 18px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/certificate/payUkey.vue